interface ShareSectionPropsType {
  title?: string;
  url?: string;
  text?: string;
  className?: string;
}

const ShareSection = ({
  title = 'この記事をシェアする',
  url = '',
  text = 'PostPrimeの最新記事',
  className = '',
}: ShareSectionPropsType) => {
  if (!url) return null;

  const shareOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text,
    )}&url=${encodeURIComponent(url)}&hashtags=PostPrime,投資,FinTech`;
    window.open(twitterUrl, '_blank');
  };

  const shareOnFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url,
    )}`;
    window.open(facebookUrl, '_blank');
  };

  const shareOnLinkedIn = () => {
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      url,
    )}`;
    window.open(linkedInUrl, '_blank');
  };

  return (
    <div
      className={`mt-10 border-t border-gray-200 pt-10 text-center ${className}`}
    >
      <h4 className="mb-4 text-base font-semibold text-gray-500">{title}</h4>
      <div className="flex justify-center gap-4">
        <button
          onClick={shareOnTwitter}
          className="flex size-12 items-center justify-center rounded-full border border-gray-200 bg-gray-50 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-100"
          aria-label="Twitter"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#262626">
            {/* X (Twitter) logo */}
            <path d="M17.53 2H21.5L14.89 10.01L22.67 22H15.87L11.13 15.09L5.77 22H1.8L8.79 13.43L1.33 2H8.3L12.62 8.32L17.53 2ZM16.32 20H18.29L7.78 3.89H5.68L16.32 20Z" />
          </svg>
        </button>
        <button
          onClick={shareOnFacebook}
          className="flex size-12 items-center justify-center rounded-full border border-gray-200 bg-gray-50 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-100"
          aria-label="Facebook"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#262626">
            <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
          </svg>
        </button>
        <button
          onClick={shareOnLinkedIn}
          className="flex size-12 items-center justify-center rounded-full border border-gray-200 bg-gray-50 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:bg-gray-100"
          aria-label="LinkedIn"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#262626">
            <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"></path>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ShareSection;
